import { CommonModule } from "@angular/common";

import { Component, EventEmitter, Input, OnDestroy, Output, inject, input } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { SportsTitleCasePipe } from "@sports-pipes/index";

import { Store } from "@ngrx/store";
import * as ticketSelector from "@sports-features/ticket/stores/ticket.selectors";
import { BetslipFilter } from "@sports-pages/betslip/models/betslip.model";
import { ticketState } from "@sports-pages/ticket/models";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "ticket-filter",
  templateUrl: "./ticket-filter.html",
  styleUrls: ["./ticket-filter.scss"],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, SportsTitleCasePipe],
})
export class TicketFilterComponent implements OnDestroy {
  // filters = input();
  // selectedFilter = input();
  filters: BetslipFilter[];
  selectedFilter: BetslipFilter;
  keyboard = input();
  @Input() disabled: boolean = false;
  @Output() selectFilter: EventEmitter<any> = new EventEmitter();
  store = inject(Store<ticketState>);

  public unsubscribe$ = new Subject<boolean>();

  constructor() {
    this.store
      .select(ticketSelector.getFilters)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((filtersState) => {
        this.filters = filtersState.filters;
        this.selectedFilter = filtersState.selectedFilter;
      });
  }

  /**
   * Selects an emmit the category selection
   * @param cat
   * @param index
   */
  onClick(cat, index) {
    this.selectFilter.emit({ ...cat, index });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
